import React, { useContext, useEffect, useState } from 'react'
import { withAuthenticationRequired } from '@auth0/auth0-react'
import { Col, Row } from 'antd'
import logger from '../../shared/logger'
import { SocketContext } from '../../context/SocketContext'

const LiveDashboard = (props) => {
  const socket = useContext(SocketContext)
  const [tournament, setTournament] = useState()

  useEffect(() => {
    logger.log('sending tournament:info')
    socket.emit('tournament:info', { id: props.id })
    socket.on('tournament:info', (tournament) => {
      logger.log('tournament', { tournament })
      setTournament(tournament)
    })
  }, [props.tournamentId])

  return (
    <>DASHBOARD</>
  )
}

export default withAuthenticationRequired(LiveDashboard, {
  onRedirecting: () => (
    <Row>
      <Col span={24} style={{ textAlign: 'center' }}>Loading</Col>
    </Row>
  )
})
